/** Textes communs à tout le logiciel — le français fait foi. */
export const commun = {
  /** Le statut technique ne s'affiche jamais : on montre ce libellé. */
  statuts: {
    option: 'Option', confirmee: 'Confirmée', en_cours: 'En cours', terminee: 'Terminée',
    annulee: 'Annulée', non_restitue: 'Non restitué',
    disponible: 'Disponible', loue: 'Louée', entretien: 'Entretien', immobilise: 'Immobilisée', vendu: 'Vendue',
    archive: 'Archivée',
    detenue: 'Détenue', restituee: 'Restituée', retenue_partielle: 'Retenue partielle', saisie: 'Saisie',
    brouillon: 'Brouillon', actif: 'Actif', clos: 'Clos', resilie: 'Résilié',
    en_attente: 'En attente', accordee: 'Accordée', refusee: 'Refusée',
    non_declare: 'Non déclaré', declare: 'Déclaré', expertise: 'Expertise',
    accepte: 'Accepté', refuse: 'Refusé', rembourse: 'Remboursé',
  } as Record<string, string>,
  roles: {
    gerant_finances: 'Gérant · finances',
    gerant: 'Gérant',
    agent: 'Agent',
  } as Record<string, string>,
  actions: {
    annuler: 'Annuler', enregistrer: 'Enregistrer', fermer: 'Fermer', valider: 'Valider',
    modifier: 'Modifier', supprimer: 'Supprimer', ajouter: 'Ajouter', imprimer: 'Imprimer',
    rechercher: 'Rechercher', reessayer: 'Réessayer', retour: 'Retour', suivant: 'Suivant',
    precedent: 'Précédent', confirmer: 'Confirmer', voir: 'Voir', ouvrir: 'Ouvrir',
  },
  langue: { choisir: 'Langue', changer: 'Changer de langue' },
  chargement: 'Chargement…',
  aucun: 'Aucun',
  oui: 'Oui',
  non: 'Non',
  erreurReseau: 'Le serveur ne répond pas',
  erreurGenerique: 'Une erreur est survenue',
  /** Le moindre écart de taille d'une liste : « 1 location », « 3 locations ». */
  pluriel: (n: number, un: string, plusieurs: string) => `${n} ${n > 1 ? plusieurs : un}`,
};
